import script from "./FileUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploader.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploader.vue?vue&type=style&index=0&id=287f54f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-287f54f3"]])

export default __exports__